import CryptoJS from "crypto-js";
 
const key = "zentixs_sso";
 
// 🔐 Encrypt
export const encrypt = (value: any): string => {
  if (value === null || value === undefined) return "";
 
  const strValue = value.toString();
 
  try {
    const encrypted = CryptoJS.AES.encrypt(strValue, key).toString();
 
    // Encode encrypted string for URL safety
    return encodeURIComponent(encrypted);
  } catch (err) {
    console.error("Encryption error:", err);
    return "";
  }
};
 
// 🔓 Decrypt
export const decrypt = (value: any): any => {
  if (!value) return value;
 
  try {
    let decoded = value;
 
    // ✅ Step 1: Decode encrypted URL layer
    try {
      decoded = decodeURIComponent(decoded);
    } catch {}
 
    // ✅ Step 2: Fix spaces → +
    decoded = decoded.replace(/ /g, "+");
 
    // ✅ Step 3: Decrypt
    const decrypted = CryptoJS.AES.decrypt(decoded, key);
    let val = decrypted.toString(CryptoJS.enc.Utf8);
 
    if (!val) return decoded;
 
    // ✅ Step 4: Decode ORIGINAL value (this was missing)
    try {
      val = decodeURIComponent(val);
    } catch {}
 
    // ✅ Step 5: Return number or string
    return !isNaN(Number(val)) ? parseInt(val) : val;
  } catch (err) {
    console.error("Decryption error:", err);
    return value;
  }
};
 